export enum ColumnShowType {
    Fixed = 'fixed',
    Captioned = 'captioned',
    Collapsed = 'collapsed',
    Hidden = 'hidden',
}
